import { useTranslation } from 'react-i18next';
import AdventureCard from '../../../components/AdventureCard';
import Check from '../../../assets/designSystem/icons/firstAid/Check.svg';
import Forbidden from '../../../assets/designSystem/icons/firstAid/Forbidden.svg';
import ChatBubble from '../../../components/ChatBubble/ChatBubble';

export default function Quiz({ introduction, question, setChoice, setAnsweredQuestion, answer, options }) {
  const { t } = useTranslation();
  const OPTIONS = [
    { label: t(options[0]), icon: Check, color: '#14C7C4' },
    { label: t(options[1]), icon: Forbidden, color: '#51A0CD' },
  ];
  return (
    <div className="quiz__container">
      <ChatBubble text={t(introduction)} />
      <AdventureCard quiz text={t(question)} />
      <div className="procedure__container">
        {OPTIONS.map((option) => {
          return (
            <Option
              key={option.label}
              {...option}
              onClick={() => {
                setChoice(t(option.label));
                setAnsweredQuestion(t(answer));
              }}
            />
          );
        })}
      </div>
    </div>
  );
}

function Option({ color, label, icon, onClick }) {
  return (
    <button type="button" className="qstnCard__container" style={{ backgroundColor: color }} onClick={onClick}>
      <img alt="img" src={icon} />
      <p className="card__label">{label}</p>
    </button>
  );
}
